export default __webpack_public_path__ + "static/media/cursor-click.fe6970f1.svg";